export default "__VITE_ASSET__e8a2293b__"